import { render } from "./TheHeader.vue?vue&type=template&id=3a0d331c&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=3a0d331c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Development\\saska-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0d331c"]])

export default __exports__